import styled from 'styled-components'

import { mq, sizes } from '../../theme'
import ContentCard from '../ContentCard'
import ContentCardGroup from '../ContentCardGroup'

export const Cards = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 2.9rem;
  & > *:not(:first-child) {
    margin-top: 1rem;
  }
  @media ${mq(sizes.desktop)} {
    flex-flow: row wrap;
    & > *,
    & > *:not(:first-child) {
      margin-top: 4rem;
    }
    & > * {
      flex: 0 0 auto;
    }
  }
`
export const Card = styled(ContentCard)`
  @media ${mq(sizes.desktop)} {
    width: calc(92% / 3);
  }
`
export const CardsGroup = styled(ContentCardGroup)`
  @media ${mq(sizes.desktop)} {
    // the double card is artificially smaller by 40px
    width: calc(100% / 3 * 2 - 4rem - 4rem);
  }
`
